import { NgModule } from '@angular/core';
import { S140gS140m01Component } from './s140g-s140m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S140gS140m01Component]
})
export class S140gModule { }

